// reducers/nodesReducer.js
import { createSlice } from "@reduxjs/toolkit";
import { createSelector } from "@reduxjs/toolkit";

export const nodesslice = createSlice({
  name: "nodes",
  initialState: {
    nodess: [],
    rootId :null,
  },
  reducers: {
    seteditedNewNodes: (state, action) => {
      // //// console.log(action.payload)
      // Only update if data actually changed
      if (state.nodess !== action.payload) {
        state.nodess = action.payload;
      }
    },
    setRootId: (state, action) => {
      state.rootId = action.payload;
    },
    AddNewnodes: (state, action) => {
      state.nodess = [...state.nodess, action.payload]; // takes new node and adds it to the node array
    },
    AddNewnodeArray: (state, action) => {
      //// console.log("sss")
      // Use utility function to combine and format nodes
      // state.nodess = formatAndCombineNodes(state.nodess, action.payload);
      state.nodess = [...state.nodess, ...action.payload];
    },
    updatenodess: (state, action) => {
      let data = action.payload;
      let index = state.nodess.findIndex(
        (obj) => obj.id.toString() === data.id.toString()
      );

      if (index !== -1) {
        state.nodess[index] = data;
      }
      //// console.log(  'redux data',state.nodess[0])
    },
    deleteNode: (state, action) => {
      const { nodesId, commentId } = action.payload;
      let nodesIndex = state.nodess.findIndex(
        (nodes) => nodes._id.toString() === nodesId.toString()
      );
      if (nodesIndex !== -1) {
        let comments = state.nodess[nodesIndex].comments;
        const updatedComments = comments.filter(
          (comment) => comment._id.toString() !== commentId.toString()
        );
        state.nodess[nodesIndex].comments = updatedComments;
      }
    },
    deletenodes: (state, action) => {
      let id = action.payload;
      const updatednodess = state.nodess.filter(function (nodes) {
        return nodes._id !== id;
      });
      state.nodess = updatednodess;
    },
    editComment: (state, action) => {
      const { nodesId, commentId, text } = action.payload;
      let nodesIndex = state.nodess.findIndex(
        (nodes) => nodes._id.toString() === nodesId.toString()
      );
      if (nodesIndex !== -1) {
        let commentIndex = state.nodess[nodesIndex].comments.findIndex(
          (comment) => comment._id.toString() === commentId.toString()
        );
        if (commentIndex !== -1) {
          state.nodess[nodesIndex].comments[commentIndex].text = text;
        }
      }
    },
    nodelogout: (state) => {
      state.nodess = [];
    },
  },
});

// Memoized selector - prevents unnecessary re-renders
export const selectnodess = createSelector(
  [(state) => state.nodes.nodess],
  (nodess) => nodess
);

export const selectRootId = createSelector(
  [(state) => state.nodes.rootId],
  (rootId) => rootId
);

export const {
  seteditedNewNodes,
  setRootId,
  AddNewnodeArray,
  updatenodess,
  deleteNode,
  AddNewnodes,
  deleteComment,
  editComment,
  nodelogout,
} = nodesslice.actions; // actions
export default nodesslice.reducer;
